import type { IntlShape } from "react-intl";

export type FinancialSegmentsIndicatorName =
  | "Operating Revenue"
  | "Operating Income"
  | "Net Interest Income"
  | "Non-Interest Income"
  | "Premiums Earned"
  | "Total Assets"
  | "Total Non-Current Assets"
  | "Net Income Available to Common Stockholders"
  | "Capital Expenditures"
  | "Pretax Income";

export default function genIndicatorsByNameMap(intl: IntlShape): Record<
  FinancialSegmentsIndicatorName,
  {
    name: string;
    abbreviation: string;
    description: string;
  }
> {
  return {
    "Operating Revenue": {
      name: intl.formatMessage({ defaultMessage: "Receita Operacional", id: "IvXaAH" }),
      abbreviation: intl.formatMessage({ defaultMessage: "Receita Op.", id: "Umrhuj" }),
      description: intl.formatMessage({
        defaultMessage: `Montante gerado pelas atividades principais da empresa.`,
        id: "Gj2MYc",
      }),
    },
    "Operating Income": {
      name: intl.formatMessage({ defaultMessage: "Lucro Operacional", id: "jqDRS8" }),
      abbreviation: intl.formatMessage({ defaultMessage: "Lucro Op.", id: "t0o4E+" }),
      description: intl.formatMessage({
        defaultMessage: `Resultado financeiro após dedução das despesas operacionais.`,
        id: "U32SP8",
      }),
    },
    "Net Interest Income": {
      name: intl.formatMessage({ defaultMessage: "Receita de Juros Líquida", id: "RarMuP" }),
      abbreviation: intl.formatMessage({ defaultMessage: "Rec. de Juros Líq.", id: "ZarDTs" }),
      description: intl.formatMessage({
        defaultMessage: `Diferença entre receitas e custos financeiros líquidos.`,
        id: "SAR5p3",
      }),
    },
    "Non-Interest Income": {
      name: intl.formatMessage({ defaultMessage: "Receitas não Financeiras", id: "dog6QQ" }),
      abbreviation: intl.formatMessage({ defaultMessage: "Receitas não Financeiras", id: "dog6QQ" }),
      description: intl.formatMessage({
        defaultMessage: `Ganhos provenientes de fontes não relacionadas a serviços financeiros.`,
        id: "1NdxEW",
      }),
    },
    "Premiums Earned": {
      name: intl.formatMessage({ defaultMessage: "Prêmios Recebidos", id: "vFtwFT" }),
      abbreviation: intl.formatMessage({ defaultMessage: "Prêmios Recebidos", id: "vFtwFT" }),
      description: intl.formatMessage({
        defaultMessage: `Valores recebidos por uma seguradora em troca de cobertura de riscos.`,
        id: "+lOzho",
      }),
    },
    "Total Assets": {
      name: intl.formatMessage({ defaultMessage: "Ativos Totais", id: "wP1gZf" }),
      abbreviation: intl.formatMessage({ defaultMessage: "Ativos Totais", id: "wP1gZf" }),
      description: intl.formatMessage({
        defaultMessage: `Valor total dos bens e direitos detidos pela empresa.`,
        id: "scLzjx",
      }),
    },
    "Total Non-Current Assets": {
      name: intl.formatMessage({ defaultMessage: "Total de Não Circulantes", id: "veziRk" }),
      abbreviation: intl.formatMessage({ defaultMessage: "Tot. de Não Cric.", id: "9PFf7t" }),
      description: intl.formatMessage({
        defaultMessage: `Valor dos ativos de longo prazo não esperados para serem convertidos em dinheiro no curto prazo.`,
        id: "g/gRHw",
      }),
    },
    "Net Income Available to Common Stockholders": {
      name: intl.formatMessage({ defaultMessage: "Lucro Líquido Disponível para Acionistas Comuns", id: "EEnbWl" }),
      abbreviation: intl.formatMessage({
        defaultMessage: "LL Disponível para ONs",
        id: "+s9VWt",
      }),
      description: intl.formatMessage({
        defaultMessage: `Lucro destinado aos acionistas após deduções.`,
        id: "K6lwfU",
      }),
    },
    "Capital Expenditures": {
      name: intl.formatMessage({ defaultMessage: "CAPEX", id: "BESDhm" }),
      abbreviation: intl.formatMessage({ defaultMessage: "CAPEX", id: "BESDhm" }),
      description: intl.formatMessage({
        defaultMessage: `Gastos com investimentos em ativos de longo prazo.`,
        id: "OY9RtY",
      }),
    },
    "Pretax Income": {
      name: intl.formatMessage({ defaultMessage: "Lucro antes dos Impostos", id: "s4/b6x" }),
      abbreviation: intl.formatMessage({ defaultMessage: "EBT", id: "o+SoFJ" }),
      description: intl.formatMessage({ defaultMessage: `Lucro gerado antes da dedução de impostos.`, id: "sQpSVA" }),
    },
  } as const;
}
